<template>
  <div class="card card-title-with-bg">
    <a :href="article.getLink()"
      v-focus
      v-if="elementToFocusOn"
    >
      <div>
        <h3 class="card-title">{{article.getTitle()}}</h3>
        <p class="desc hidden-small desc-clamp" v-html="$sanitize(article.getChapo())" />
      </div>
      <div class="btn-arrow btn-round-icon-only"></div>
    </a>
    <a :href="article.getLink()"
      v-else
    >
      <div>
        <h3 class="card-title">{{article.getTitle()}}</h3>
        <p class="desc hidden-small desc-clamp" v-html="$sanitize(article.getChapo())" />
      </div>
      <div class="btn-arrow btn-round-icon-only"></div>
    </a>
  </div>
</template>
<script>

const focus = {
  mounted: (el) => el.focus(),
};

export default {
  directives: {
    focus,
  },
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
    elementToFocusOn: {
      type: Boolean,
      default: false,
    },
    cardIndex: {
      type: Number,
      default: 0,
    },
    trackLabel: {
      type: String,
      default: '',
    },
  },

};
</script>
